const SetStoreMapper = require('../shoplocator/atm/set-store-mapper');
const _ = require('lodash');

module.exports = function (StorePickerPanelService, moveFocus, StorePickerService, shopLocatorService, atm, $sce, $state, settingsService, bwsNotificationService, geolocation, googleMapsApi, BreakpointsService, trolleyService, $window) {
    return {
        restrict: 'E',
        scope: {
        },
        controllerAs: 'vm',
        link(scope) {
            scope.hideFindStoreHeader = true;
            scope.isSearchEnabled = false;
            scope.shopLocator = shopLocatorService;
            scope.storePicker = StorePickerService;
            scope.setSelectedValue = { mode: true };
            scope.storePickerPanelService = StorePickerPanelService;
            scope.storePickerPanelService.showStoreList = false;
            scope.hasStoreList = (Array.isArray(scope.storesList) && scope.storesList.length);
            scope.storeLocation = StorePickerPanelService.deliverySearch;
            scope.searchingStoresNearYou = false;
            scope.isSettingStore = false;
            scope.breakpointsService = BreakpointsService;
			scope.storePagesRedirectSettings = null;
            StorePickerPanelService.showStorePrompt = !scope.storePickerPanelService.changeStoreView && !scope.storePicker.fulfilmentInfo.IsSystemAddress ? true : false;
            scope.vm = {
                isMobileScreen: window.innerWidth < 768
            };

            const deliveryOptions = [
                {
                    type: 'Pick Up',
                    icon: 'icon--lock'
                },
                {
                    type: 'Delivery',
                    icon: 'icon--truck'
                },
                {
                    type: 'In-store',
                    icon: 'icon--store'
                }
            ];

            scope.typeOptions = _.clone(deliveryOptions);

            settingsService.getFrontendSetting('storeStatus', 'StoreClosureMessage').then(function (response) {
                if (response && response[0].Value) {
                    scope.storeHoursOverridden = $sce.trustAsHtml(response[0].Value);
                }
            });

            settingsService.getFrontendSetting('StorePages', 'StorePagesRedirect')
				.then((res) => {
                    scope.storePagesRedirectSettings = JSON.parse(res[0].Value);
                });

            function storesNearYou() {

                if (geolocation && geolocation.getCurrentPosition !== undefined) {
                    // Clear the delivery suburb info, before we call api for suburb near current location.
                    StorePickerPanelService.deliverySearch = {};
                    scope.hasStoreList = false;
                    scope.storesList = [];

                    geolocation.getCurrentPosition(
                        function (position) {

                            scope.searchingStoresNearYou = true;

                            shopLocatorService.listSupermarkets({
                                Max: 30,
                                Latitude: position.coords.latitude,
                                Longitude: position.coords.longitude
                            }).then(function (locations) {
                                scope.storeListTitle = 'Stores near you';
                                scope.storesList = locations.Stores;
                                scope.deliveryStores = locations.DeliveryStores;
                                scope.searching = false;
                                scope.storePickerPanelService.fullfillmentOptions.disableFullfillmentOptions = false;
                                StorePickerPanelService.showStorePrompt = false;
                                StorePickerPanelService.changeStoreView = true;
                                scope.hasStoreList = true;
                                if (scope.deliveryStores.length) {

                                    googleMapsApi().then(function (google) {
                                        const geocoder = new google.maps.Geocoder;
                                        const location = { lat: position.coords.latitude, lng: position.coords.longitude };

                                        geocoder.geocode({ location }, function (results, status) {
                                            if (status === 'OK') {

                                                let postcode, suburb;

                                                if (results[0]) {
                                                    _.filter(results[0].address_components, function (obj) {
                                                        if (obj.types[0] === 'postal_code') {
                                                            postcode = obj.long_name;
                                                        }
                                                        if (obj.types[0] === 'locality') {
                                                            suburb = obj.long_name;
                                                        }

                                                    });

                                                    StorePickerPanelService.deliverySearch = {
                                                        FulfilmentStoreID: scope.deliveryStores[0].StoreNo,
                                                        SuburbName: suburb,
                                                        PostCode: postcode
                                                    };

                                                } else {
                                                    console.log('No results found');
                                                }

                                            } else {
                                                console.log('Geocoder failed due to: ' + status);
                                            }
                                        });
                                    });
                                }
                                scope.searchingStoresNearYou = false;
                            });
                        }, function () {
                            scope.searching = false;
                            StorePickerPanelService.changeStoreView = true;
                            scope.hasStoreList = false;
                            scope.searchingStoresNearYou = false;
                            if (scope.storePicker.fulfilmentInfo.IsSystemAddress) {
                                StorePickerPanelService.showStorePrompt = true;
                            }
                        }
                    );
                }
            }

            scope.goToStoreView = function () {
                StorePickerPanelService.changeStoreView = true;
                StorePickerPanelService.showStorePrompt = false;
            };

            scope.$watch('storePicker.delivery', function (delivery) {
                if (!delivery.allowed) {
                    scope.typeOptions = _.reject(_.clone(deliveryOptions), {
                        type: 'Delivery',
                        icon: 'icon--truck'
                    });
                } else {
                    scope.typeOptions = _.clone(deliveryOptions);
                }
            }, true);

            scope.$watch('storePicker.store', function (store, oldStore) {
                if (scope.storePicker.fulfilmentMethod === 'Delivery') {

                    if (store.FulfilmentStoreID !== oldStore.FulfilmentStoreID) {
                        scope.storeLocation = StorePickerPanelService.deliverySearch;
                    }
                } else {
                    return false;
                }
            }, true);

            scope.$watch('storePickerPanelService.changeStoreView', function (val) {
                if (val && StorePickerPanelService.isOpen) {
                    storesNearYou();
                }
            }, true);

            scope.getStoreInfoUrlParams = function (store) {
                scope.storePickerPanelService.close();

                if (scope.storePagesRedirectSettings && scope.storePagesRedirectSettings.EnableRedirect) {
                    const suburbYextFormat = store.Suburb.trim().replace(/\s+/g, '-');
					let storePathUrl = `${scope.storePagesRedirectSettings.RedirectBaseUrl}/${store.State}-${suburbYextFormat}-${store.StoreNo}`;
					storePathUrl = storePathUrl.toLocaleLowerCase();
					$window.location.assign(storePathUrl);
				} else {
                    $state.go('shop.locator.store', { store: scope.shopLocator.generateUrlParamsForStoreInfos(store) });
                }
            };

            scope.setFullfillmentMethod = function (fullfillmentType, $index) {
                scope.selectedIndex = $index;
                scope.storePicker.type = fullfillmentType;

                //Click and collect
                if (scope.storePicker.type === 'Pick Up' || scope.storePicker.type === 'In-store') {
                    shopLocatorService.searchSupermarketByPostcode(scope.storePicker.store.PostCode, 10).then(function (stores) {
                        scope.storesList = stores;

                        scope.storePickerPanelService.showStoreList = true;
                        scope.selectedIndex = null;
                    });
                    moveFocus('.shop-locator-search-panel');
                }
                // Delivery
                if (scope.storePicker.type === 'Delivery') {
                    scope.storePicker.setDeliveryByStoreNo(scope.deliveryStores[0].StoreNo).then(function () {
                        scope.storePickerPanelService.close();

                        const fulfilmentInfo = scope.storePicker.fulfilmentInfo.DeliveryDetails;

                        // Disable the delivery method options
                        scope.storePickerPanelService.fullfillmentOptions.disableFullfillmentOptions = true;
                        scope.storePicker.store.SuburbName = fulfilmentInfo.FulfilmentStoreID;

                        const defaultSelectedStoreOrder = 0;

                        const atmData = {
                            event: 'BWSAUupdateStorePreference',
                            store: {
                                StoreNo: fulfilmentInfo.FulfilmentStoreID,
                                Postcode: fulfilmentInfo.StoreAddressPostalCode,
                                Name: fulfilmentInfo.FulfilmentStoreName,
                                SelectedStoreOrder: defaultSelectedStoreOrder.toString()
                            },
                            fulfilmentInfo
                        };

                        atm.push(atmData, SetStoreMapper);
                        StorePickerPanelService.setSuburbInLocalStorage(StorePickerPanelService.deliverySearch);
                        scope.storeLocation = StorePickerPanelService.deliverySearch;
                        $state.forceReload(); // not a good idea

                        bwsNotificationService.success(`Delivery to <strong>${scope.storeLocation.SuburbName}</strong> has been set.`);
                    });
                }

            };

            //Sets click and collect and in-store store
            scope.setSelectedStore = function (store) {
                scope.isSettingStore = true;
                store.activeSetStore = true;
                scope.storePicker.setPickupByStoreNo(store.StoreNo).then((fulfilmentInfo) => {
                    scope.storePickerPanelService.close();
                    scope.storePickerPanelService.showStoreList = false;
                    scope.storePickerPanelService.fullfillmentOptions.disableFullfillmentOptions = true;

                    store.SelectedStoreOrder = (scope.storesList.indexOf(store) + 1).toString();

                    const atmData = {
                        event: 'BWSAUupdateStorePreference',
                        store,
                        fulfilmentInfo
                    };

                    atm.push(atmData, SetStoreMapper);

                    $state.forceReload();
                    bwsNotificationService.success(`You\'re browsing <strong>BWS ${store.Name}</strong>.`);

                }).finally(function () {
                    scope.isSettingStore = false;
                    delete store.activeSetStore;
                });
            };

            scope.searchStores = function () {
                shopLocatorService.listSupermarkets({
                    Max: 15,
                    Latitude: scope.storePicker.store.Latitude,
                    Longitude: scope.storePicker.store.Longitude
                }).then(function (stores) {
                    scope.storesList = stores.Stores;
                    scope.deliveryStores = stores.DeliveryStores;
                    if (scope.deliveryStores.length) {
                        StorePickerPanelService.deliverySearch.FulfilmentStoreID = scope.deliveryStores[0].StoreNo;
                        StorePickerPanelService.setSuburbInLocalStorage(StorePickerPanelService.deliverySearch);
                    }

                    const atmData = {
                        event: 'BWSAUselectStoreSuburb',
                        store: {
                            SelectedSuburb: scope.storePicker.store.SuburbStateString,
                            SetDeliveryvisible: (scope.deliveryStores.length > 0 && scope.storePicker.delivery.allowed).toString()
                        }
                    };

                    atm.pushWithStoreMapper(atmData);

                    scope.storeListTitle = 'View availability and pricing for';
                    scope.hasStoreList = true;
                });
            };

            scope.typeChanged = function () {
                scope.isSearchEnabled = false;
            };

            scope.expand = function () {
                scope.isSearchEnabled = true;
            };

            scope.gotoHome = function () {
                $state.go('home');
                scope.closePanel();
            };

            scope.closePanel = function () {
                StorePickerPanelService.close();
                scope.$root.$broadcast('mobileStorePickerPanelOverlayClose');
            };

            scope.openTrolley = function () {
                scope.closePanel();
                setTimeout(function () {
                    $('#dummy-trolley-button').click();
                }, 0);
            };

            scope.trolleyCount = function () {
                return _.sumBy(trolleyService.trolleyProducts, 'Quantity') +
                    _.sumBy(trolleyService.unavailableProducts, 'Quantity') +
                    _.sumBy(trolleyService.partiallyUnavailableProducts, 'Quantity');
            };

            scope.$on('window:resize', function () {
                scope.$apply(function () {
                    scope.vm.isMobileScreen = window.innerWidth < 768;
                });
            });

            scope.showPanel = function () {
                StorePickerPanelService.showStorePrompt = false;
                const atmData = {
                    event: 'BWSlinkClick',
                    eventContext:{
                        area: "location prompt",
                        linkType: "location prompt cta",
                        linkName: "web:location prompt:cta:enter postcode or suburb", 
                    }
                };
                atm.push(atmData);
            };
            scope.closePanel = function () {
                StorePickerPanelService.close();
                const atmData = {
                    event: 'BWSlinkClick',
                    eventContext:{
                        area: "location prompt",
                        linkType: "location prompt cta",
                        linkName: "web:location prompt:cta:do this later", 
                    }
                };
                atm.push(atmData);
            };
            (function init() {
                moveFocus('.js-store-picker-panel');
            })();
        },
        template: require('./store-picker-panel-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/storepicker/store-picker-panel-directive.js
 **/